import React, { useState, useEffect, useRef } from 'react';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import BuggyPreloader from './components/BuggyPreloader';
import TerminalLanding from './components/TerminalLanding';
import Portfolio from './components/Portfolio';
import CustomCursor from './components/CustomCursor';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

function App() {
    const [showPreloader, setShowPreloader] = useState(true);
    const [showTerminal, setShowTerminal] = useState(false);
    const [showPortfolio, setShowPortfolio] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const lenisRef = useRef(null);

    const handlePreloaderComplete = () => {
        setShowPreloader(false);
        setShowTerminal(true);
    };

    const handleEnterPress = () => {
        setShowTerminal(false);
        setIsTransitioning(true);
        setTimeout(() => {
            setShowPortfolio(true);
            setIsTransitioning(false);
        }, 1200);
    };

    // Initialize Lenis smooth scroll when portfolio is shown
    useEffect(() => {
        if (showPortfolio) {
            // Initialize Lenis
            const lenis = new Lenis({
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                orientation: 'vertical',
                gestureOrientation: 'vertical',
                smoothWheel: true,
                wheelMultiplier: 1,
                smoothTouch: false,
                touchMultiplier: 2,
                infinite: false,
            });

            lenisRef.current = lenis;

            // Sync Lenis with GSAP ScrollTrigger
            lenis.on('scroll', ScrollTrigger.update);

            gsap.ticker.add((time) => {
                lenis.raf(time * 1000);
            });

            gsap.ticker.lagSmoothing(0);

            // Cleanup
            return () => {
                lenis.destroy();
                gsap.ticker.remove(lenis.raf);
            };
        }
    }, [showPortfolio]);

    return (
        <div className="App">
            {/* Custom Cursor - only on desktop */}
            <CustomCursor />

            {showPreloader && (
                <BuggyPreloader onComplete={handlePreloaderComplete} />
            )}

            {isTransitioning && (
                <div className="white-transition-overlay"></div>
            )}

            {showTerminal && (
                <TerminalLanding onEnterPress={handleEnterPress} />
            )}

            {showPortfolio && (
                <Portfolio />
            )}
        </div>
    );
}

export default App;